import axios from 'api/axios';

export const getRoles = () =>
    axios<API.Role[] | null>({
        method: 'GET',
        url: 'roles'
    });
